// import Tippy from "@tippyjs/react";
import React from "react";
import InformationTooltip from "../Tooltips/InformationTooltip";

const VerticalRadioButtons = ({
    name,
    options,
    onChangeHandler,
    checkedReference,
    wrapperClassName = "my-1",
    labelClassName = "",
    disabled = false,
}) => {
    const renderOptions = () => {
        return (
            <>
                {options &&
                    options.map((option, index) => {
                        return (
                            <div
                                className={`flex items-center ${
                                    disabled ? "opacity-60" : ""
                                } ${wrapperClassName}`}
                                key={index}
                            >
                                <div
                                    className={`radio-wrapper-input mr-2 ${
                                        option.disabled ? "disabled" : ""
                                    }`}
                                >
                                    <input
                                        type="radio"
                                        className="radio-element pl-3"
                                        disabled={option.disabled || disabled}
                                        name={name}
                                        id={`${name}-radio-ele-${index}`}
                                        checked={
                                            checkedReference === option.name ||
                                            checkedReference === option.label ||
                                            checkedReference === option.value
                                        }
                                        onChange={onChangeHandler}
                                        value={option.value}
                                    />
                                    <label
                                        htmlFor={`${name}-radio-ele-${index}`}
                                        disabled={option.disabled}
                                        className={`text-primary-blue mb-0 ${
                                            option.disabled ? "disabled" : ""
                                        } ${labelClassName}`}
                                    >
                                        {option.label}
                                    </label>
                                </div>
                                {option.tooltip && (
                                    <InformationTooltip
                                        message={option.tooltip}
                                        className="fa-xs"
                                    />
                                )}
                            </div>
                        );
                    })}
            </>
        );
    };

    return <>{renderOptions()}</>;
};

export default VerticalRadioButtons;
